module.exports = __webpack_public_path__ + "img/info-circle.ad7dceb3.svg";